/* eslint-disable no-console */
export const isLocalhost = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return hostname === 'localhost';
  } catch (error) {
    return false;
  }
};

export const isTestEnvironment = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return hostname === 'www-t.storebrand.no';
  } catch (error) {
    return false;
  }
};
